// @ts-nocheck
import { populate } from 'populate';
import type { Container, Sprite } from 'pixi.js';

const raw = {
  list: [
    {
      id: 'c317e9e1-aec4-42d5-afc1-e7e75a0d842a',
      type: 'Container',
      name: 'root',
      className: '',
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: ''
    },
    {
      id: '3ff3c924-eff8-4c88-a854-da35e6112147',
      type: 'Sprite',
      name: '',
      className: '',
      x: 0,
      y: 9,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Item_Blue_Background_Variation',
      parent: 'c317e9e1-aec4-42d5-afc1-e7e75a0d842a',
      data: {
        DEBUG: true
      }
    },
    {
      id: 'b95cf524-8319-4832-a714-ed36a0ed9b73',
      type: 'Sprite',
      name: 'mark',
      className: '',
      x: 96,
      y: 63,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Check',
      parent: 'c317e9e1-aec4-42d5-afc1-e7e75a0d842a'
    }
  ],
  x: 0,
  y: 0,
  width: 760,
  height: 760,
  version: '3.1.0',
  animations: [
    {
      id: '3502f165-7012-4916-a47d-5cbbddb6c3b6',
      name: 'appear',
      playingSpeed: 1,
      totalDuration: 300,
      blocks: [
        {
          id: '4b7f504d-27b0-42d0-8e87-fa6223778270',
          type: 'Setter',
          name: 'New_setter',
          track: 1,
          target: {
            scale: {
              x: 0,
              y: 0
            }
          },
          startAt: 0,
          sourceName: 'mark',
          disabled: false
        },
        {
          id: '53c0a855-5a27-443c-81ad-307746d43a55',
          type: 'Tween',
          name: 'New_tween',
          duration: 300,
          track: 1,
          target: {
            scale: {
              x: 1,
              y: 1
            }
          },
          startAt: 0,
          sourceName: 'mark',
          easing: 'ElasticOut',
          disabled: false
        }
      ]
    },
    {
      id: 'bb9918f4-c342-48c5-9fe5-d92589508a5c',
      name: 'disappear',
      playingSpeed: 1,
      totalDuration: 300,
      blocks: [
        {
          id: '4dfa9931-6101-4885-82a3-d62f4c9c11a6',
          type: 'Tween',
          name: 'disappearTween',
          duration: 300,
          track: 1,
          target: {
            scale: {
              x: 0,
              y: 0
            }
          },
          startAt: 0,
          sourceName: 'mark',
          easing: 'ElasticIn',
          disabled: false
        }
      ]
    }
  ],
  handleResize: false
} as const;

export class SeasonPassRewardCheckmarkLayout {
  static raw = raw;
  root!: Container;
  mark!: Sprite;
  StateName!: never;

  constructor() {
    populate(this, raw);
  }
}

export abstract class appear {
  Layout: {
    mark: object;
  };

  BlockTypeByName: {
    New_setter: object;
    New_tween: object;
  };

  flowData = raw.animations[0];
}

export abstract class disappear {
  Layout: {
    mark: object;
  };

  BlockTypeByName: {
    disappearTween: object;
  };

  flowData = raw.animations[1];
}
